// extracted by mini-css-extract-plugin
export default {"viewer":"CollectibleCoinViewer_viewer__Rqu4d","canvas":"CollectibleCoinViewer_canvas__mX5da"};